import { render, staticRenderFns } from "./TestMailModal.vue?vue&type=template&id=4ee2d7c1&lang=pug"
import script from "./TestMailModal.vue?vue&type=script&lang=ts"
export * from "./TestMailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports